window.BODY_ELEMENT = document.querySelector('body');
window.MAINNAV_ELEMENT = document.querySelector('.mainnav');
window.EARTH_ELEMENT = document.querySelector('.earth');
